import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
export const StyledIconContainer = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;

  transform: scaleX(${(props) => (props.prev ? -1 : 1)});

  backface-visibility: hidden;

  [dir='rtl'] & {
    transform: scaleX(${(props) => (props.next ? -1 : 1)});
  }
`;
export const StyledArrow = styled.svg `
  width: 0.5em;
  height: 0.8125em;
`;
export const StyledPaginationItem = styled.li `
  display: inline-block;
  box-sizing: content-box;

  line-height: 24px;
  vertical-align: baseline;

  cursor: pointer;

  * {
    margin: 0;
    padding: 0;

    color: ${(props) => props.theme.colors.text.inactive};

    font: inherit;

    transition: 150ms ${(props) => props.theme.easing};
    transition-property: color;
  }

  button,
  a {
    display: inline-block;
    min-width: 24px;
    min-height: 24px;

    text-align: center;
    text-decoration: none;

    background-color: transparent;
    border: none;

    appearance: none;

    padding-inline-start: var(${(props) => props.theme.responsive.spacing.xs});
    padding-inline-end: var(${(props) => props.theme.responsive.spacing.xs});

    &:hover {
      cursor: pointer;
    }

    &::after {
      display: block;

      border-bottom: 2px solid transparent;

      content: '';
    }
  }

  & [aria-current='page'] {
    color: ${(props) => props.theme.colors.text.primary};

    &::after {
      border-color: ${(props) => props.theme.colors.text.primary};
    }
  }

  & [aria-disabled='true'],
  & [aria-disabled='true'] * {
    color: ${(props) => props.theme.colors.utility.neutral[30]};

    cursor: not-allowed;
  }

  &:hover [aria-disabled='false'],
  &:hover [aria-disabled='false'] * {
    color: ${(props) => props.theme.colors.text.primary};
  }
`;
export const StyledPagination = styled.ul `
  display: inline;
  margin: 0;

  padding: 0;

  list-style: none;

  li {
    display: inline;
    margin-inline-end: var(
      ${(props) => props.count >= 100
    ? props.theme.responsive.spacing.xs
    : props.theme.responsive.spacing.s}
    );

    cursor: default;

    &:last-child {
      margin-inline-end: 0;
    }

    &:first-child,
    &:nth-last-child(2) {
      margin-inline-end: var(
        ${(props) => ({
    minimalWithLabels: props.theme.responsive.spacing.xl,
    compact: props.theme.responsive.spacing.xs,
    extended: props.theme.responsive.spacing.s,
    minimal: props.theme.responsive.spacing.m,
    normal: props.theme.responsive.spacing.l,
}[props.variant])}
      );
    }
  }
`;
export const StyledContainer = styled.nav `
  ${(props) => injectTypography(props, 'copy1')}
  ${injectSpacing('margin')}
`;
export const StyledCurrentPage = styled.span `
  color: ${(props) => props.theme.colors.text.primary};
`;
//# sourceMappingURL=Pagination.styles.js.map